/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";

import "../../assets/styles/admin.css";
import Loader from "../loader/loader";
import ListDatatable from "./listdatatable";
import { socket } from "../../config/socket";

const OnlineUsers = () => {
  const [loading, setLoading] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    setLoading(true);
    socket.emit("adminOnlineUsersList");
    socket.on("adminOnlineUsersList", (data) => {
      setOnlineUsers(data.list);
      setLoading(false);
    });
    return () => {
      socket.off("adminOnlineUsersList");
    };
  }, [socket]);

  return (
    <Fragment>
      <Breadcrumb title="Online Users" parent="User Management" />
      <Container fluid={true} className="index-page">
        <div className="admin-card">
          <Card>
            <CardHeader>
              <h5>Online Users ({onlineUsers?.length || 0})</h5>
            </CardHeader>
            <CardBody>
              <div className="clearfix"></div>
              <div
                id="batchDelete"
                className="category-table user-list order-table coupon-list-delete">
                {!loading ? (
                  onlineUsers && onlineUsers.length > 0 ? (
                    <ListDatatable myData={onlineUsers} />
                  ) : (
                    <p className="no-data">Currently no online users found !</p>
                  )
                ) : (
                  <Loader />
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </Fragment>
  );
};
export default OnlineUsers;
